//light animations on scroll
$(window).scroll(function() {
	  var newWindowWidth = $(window).width();
        if (newWindowWidth < 481) {
    var scroll = $(window).scrollTop();
  if (scroll >= 500 && scroll <= 800) {
  	   	 $('.img-block1').addClass('hoverItemcolor');
     $('.img-block2').removeClass('hoverItemcolor');
     $('.img-block3').removeClass('hoverItemcolor');
     $('.img-block4').removeClass('hoverItemcolor');
    }  
  else if(scroll >= 800 && scroll <= 1100){
   	 $('.img-block1').removeClass('hoverItemcolor');
     $('.img-block2').addClass('hoverItemcolor');
     $('.img-block3').removeClass('hoverItemcolor');
     $('.img-block4').removeClass('hoverItemcolor');
      }
      else if(scroll >= 1200 && scroll <= 1500){
   	 $('.img-block1').removeClass('hoverItemcolor');
     $('.img-block2').removeClass('hoverItemcolor');
     $('.img-block3').addClass('hoverItemcolor');
     $('.img-block4').removeClass('hoverItemcolor');
      }
        else if(scroll >= 1500 && scroll <= 1800){
      	 $('.img-block1').removeClass('hoverItemcolor');
     $('.img-block2').removeClass('hoverItemcolor');
     $('.img-block3').removeClass('hoverItemcolor');
     $('.img-block4').addClass('hoverItemcolor');
      }
      else{
      	 $('.img-block1').removeClass('hoverItemcolor');
     $('.img-block2').removeClass('hoverItemcolor');
     $('.img-block3').removeClass('hoverItemcolor');
     $('.img-block4').removeClass('hoverItemcolor');
      }
      }
      else if( newWindowWidth > 481 &&  newWindowWidth < 1024) {
       
      	 var scroll = $(window).scrollTop();
  if (scroll >= 400 && scroll <= 800) {
	 $('.img-block1').addClass('hoverItemcolor');
     $('.img-block2').addClass('hoverItemcolor');
     $('.img-block3').removeClass('hoverItemcolor');
     $('.img-block4').removeClass('hoverItemcolor');
    }  
    else if (scroll >= 800 && scroll <= 1024) {
 	 $('.img-block1').removeClass('hoverItemcolor');
     $('.img-block2').removeClass('hoverItemcolor');
     $('.img-block3').addClass('hoverItemcolor');
     $('.img-block4').addClass('hoverItemcolor');
    }
    else{
    	 $('.img-block1').removeClass('hoverItemcolor');
     $('.img-block2').removeClass('hoverItemcolor');
     $('.img-block3').removeClass('hoverItemcolor');
     $('.img-block4').removeClass('hoverItemcolor');
    }

      }
      else {
    var scroll = $(window).scrollTop();
   //     console.log(scroll)
  if (scroll >= 600 && scroll <= 1000) {
 
    $('.img-block1').addClass('hoverItemcolor');
     $('.img-block2').addClass('hoverItemcolor');
     $('.img-block3').removeClass('hoverItemcolor');
     $('.img-block4').removeClass('hoverItemcolor');
    } 
 else if (scroll >= 1000 && scroll <= 1800) {
 $('.img-block1').removeClass('hoverItemcolor');
     $('.img-block2').removeClass('hoverItemcolor');
     $('.img-block3').addClass('hoverItemcolor');
     $('.img-block4').addClass('hoverItemcolor');
    } 
    else {
    	 $('.img-block1').removeClass('hoverItemcolor');
     $('.img-block2').removeClass('hoverItemcolor');
     $('.img-block3').removeClass('hoverItemcolor');
     $('.img-block4').removeClass('hoverItemcolor');
      }
    }
  });

//for button click
jQuery(document).on('ready', function() {
$('.section--tight').attr("id","mainprodsection");
// $('.button-price-custom button').click(function () {
//    console.log('click');
//     $('buy-buttons button.button').trigger('click');
// })

});
//table slider for mobile
jQuery(document).on('ready', function() {
 
      var slider = jQuery('.table-slider-mob');
      slider.slick({
      arrows: true,
      dots: false,
      accessibility: false,
      infinite: true,
      autoplay: false,
      
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [{
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
     });

